import React from "react";
import "../../../styles/hero.css";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import AnimatedLogo from "../../shared/AnimatedLogo";

const Hero = () => {
    const { scrollY } = useScroll();
    
    // Create very subtle parallax transforms - negative values for upward movement
    const logoY = useTransform(scrollY, [0, window.innerHeight], [0, -100]); // Logo moves up slower (background)
    const headingY = useTransform(scrollY, [0, window.innerHeight], [0, -200]); // Heading moves up more
    const buttonsY = useTransform(scrollY, [0, window.innerHeight], [0, -50]); // Buttons move up least
    
    // Scale effect for heading - gets slightly smaller as you scroll
    const headingScale = useTransform(scrollY, [0, window.innerHeight], [1, 0.9]);
    
    // Rotation effects for logo parts - subtle counter-rotation
    const outerRotation = useTransform(scrollY, [0, window.innerHeight], [0, 15]); // Clockwise
    const innerRotation = useTransform(scrollY, [0, window.innerHeight], [0, -10]); // Counter-clockwise
    
    // Subtle darkening effect as you scroll
    const overlayOpacity = useTransform(scrollY, [0, window.innerHeight], [0, 0.15]);
    
    return (
        <div className="hero">
            <motion.div 
                className="hero-overlay"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 1)',
                    opacity: overlayOpacity,
                    pointerEvents: 'none',
                    zIndex: 0
                }}
            />
            <div className="overlay">
                <motion.div
                    className="hero-logo"
                    style={{
                        x: "-50%",
                        y: useTransform(logoY, (value) => `calc(-50% + ${value}px)`),
                        transformOrigin: "center center"
                    }}
                >
                    <AnimatedLogo 
                        outerRotation={outerRotation}
                        innerRotation={innerRotation}
                    />
                </motion.div>
                <motion.h1 
                    className="fancy-text hero-heading"
                    style={{
                        y: headingY,
                        scale: headingScale
                    }}
                >
                    LUNA PEARL
                </motion.h1>
                <motion.div 
                    className="hero-buttons"
                    style={{
                        x: "-50%",
                        y: buttonsY
                    }}
                >
                    <Link to="/contact-us" className="btn btn-light">
                        <span className="fw-semibold">CONTACT US</span>
                    </Link>
                    <Link to="what-is-reiki" className="btn btn-dark">
                        <span className="fw-medium">WHAT IS REIKI?</span>
                    </Link>
                </motion.div>
            </div>
        </div>
    );
};

export default Hero;